import { svg } from 'lit';
export const chevronDown16Svg = svg `
<svg width="16" height="16" viewBox="0 0 16 16" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 6L8 10L12 6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`;
//# sourceMappingURL=chevron-down_16.svg.js.map